import { render, staticRenderFns } from "./GlobalStockReport.vue?vue&type=template&id=a489d55c"
import script from "./GlobalStockReport.vue?vue&type=script&lang=js"
export * from "./GlobalStockReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports